import { Autocomplete, TextField, Chip } from '@mui/material'

interface DimOption {
  value: string
  label: string
}

interface Props {
  dimName: string
  options: DimOption[]
  selected: string[]
  onChange: (next: string[]) => void
}

export function DimChipSelect({ dimName, options, selected, onChange }: Props) {
  return (
    <Autocomplete
      multiple
      sx={{ minWidth: 240 }}
      options={options}
      getOptionLabel={(o) => o.label}
      getOptionKey={(o) => o.value}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      value={options.filter((o) => selected.includes(o.value))}
      onChange={(_, next) => onChange(next.map((o) => o.value))}
      renderInput={(params) => <TextField {...params} label={dimName} />}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            label={option.label}
            key={option.value}
            data-testid="dim-chip-select-tag"
          />
        ))
      }
    />
  )
}
